import { ApiApiRoute } from 'app/api-route/api/api.api';
import { ApiRoute } from 'api-base-refrence';

export class InformationApiRoute extends ApiRoute {
  static apiName = '';
  static parent = ApiApiRoute;
  static urlPattern() {
    return `/information`;
  }
}
